import { GET_TAXES_KEY_TOKEN_ERROR, GET_TAXES_KEY_USER_ERROR, GET_TAXES_KEY_USER_SUCCESS } from './TaxesKeyAuth.actions'

const taxesKeyAuthState = {
  error: false,
  isRecoveryAdmin: false,
  loading: true
}

/**
 * The taxes key auth' reducer.
 */
const taxesKeyAuthReducer = (state = taxesKeyAuthState, { payload, type }) => {
  switch (type) {
    case GET_TAXES_KEY_TOKEN_ERROR:
    case GET_TAXES_KEY_USER_ERROR: {
      return { ...state, loading: false, error: true }
    }
    case GET_TAXES_KEY_USER_SUCCESS: {
      return { ...state, loading: false, isRecoveryAdmin: payload.backup.isRecoveryAdmin }
    }
    default: {
      return state
    }
  }
}

export default taxesKeyAuthReducer
